// Subpage registry. A command enters a subpage via `api.pushPage(id)`; the
// palette looks the id up here for the input placeholder, empty-state text, and
// whether cmdk should filter results client-side.
//
// `shouldFilter: false` hands result selection to the subpage's provider — e.g.
// an async provider that already filtered server-side and shouldn't be
// re-filtered against the raw query. Use `true` for subpages whose actions are
// static and should narrow as the user types (e.g. page-specific actions).

/** @type {Record<string, import("./types").Subpage>} */
export const SUBPAGES = {
  "subscriber-search": {
    placeholder: "Search subscribers by email…",
    emptyText: "No subscribers found.",
    // Server-filtered subpage: don't fetch (or claim "no results") until the
    // query is long enough to be meaningful. The provider reads this to gate its
    // request; the palette reads it to show a "keep typing" hint below it.
    minQueryLength: 3,
    shouldFilter: false
  },
  "tag-search": {
    placeholder: "Search tags by name…",
    emptyText: "No tags found.",
    // Default for the common case: the provider preloads the full list, so cmdk
    // narrows it client-side. When an account has more tags than the preload
    // cap, the provider overrides this to `false` and searches server-side.
    shouldFilter: true
  },
  "segment-search": {
    placeholder: "Search segments by name…",
    emptyText: "No segments found.",
    // The provider preloads the full list, so cmdk narrows it client-side.
    shouldFilter: true
  },
  "broadcast-search": {
    placeholder: "Search broadcasts…",
    emptyText: "No broadcasts found.",
    // Server-filtered subpage (reuses the campaigns index search): don't fetch
    // until the query is long enough to be meaningful.
    minQueryLength: 3,
    shouldFilter: false
  },
  "sequence-search": {
    placeholder: "Search email sequences by name…",
    emptyText: "No email sequences found.",
    // The provider preloads the full list, so cmdk narrows it client-side.
    shouldFilter: true
  },
  "automation-search": {
    placeholder: "Search Visual Automations by name…",
    emptyText: "No Visual Automations found.",
    // The provider preloads the full list, so cmdk narrows it client-side.
    shouldFilter: true
  }
}
